module.exports = __webpack_public_path__ + "img/r-circle.5da3b175.svg";